import { useState, useEffect, useContext } from "react";
import { api } from "services/api";
import { getInitialObject } from "utils/globalFunctions";
import Swal from "sweetalert2";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import ReactLoading from "react-loading";
import { Customer } from "./Customer";
import { Premix } from "./Premix";
import { Enzymes } from "./Enzymes";
import { Health } from "./Health";
import { Minerals } from "./Minerals";
import { Additions } from "./Additions";
import { Modal } from "components/Modal";
import { Icons } from "components/Icons";
import { Button } from "components/Button";
import UpdateList from "contexts/updateList";
export function CreateEdit(props) {
  const { setUpdateList } = useContext(UpdateList);

  const meggProductionInit = {
    _id: null,
    dailySlaughter: "",
    healthScore: "",
    healthChallenge: "",
    knownAgents: "",
    antibiogramRecent: "",
    export: false,
    internMarket: false,
    exportCuts: "",
    exportPlaces: [],
    premixProductionYear: "",
    premixComposition: "",
    premixPlaxma: false,
    premixHemoglobin: false,
    premixAnimalFeed: false,
    premixAnimalFeedType: "",
    premixSteps: {
      preLay: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
      prePeak: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
      layPeak: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
      layFinal01: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
      layFinal02: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
      layFinal03: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
      layFinal04: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
      layFinal05: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
      layFinal06: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
    },
    enzymes: {
      phytase: {
        preLay: {
          checked: false,
          product: "",
        },
        prePeak: {
          checked: false,
          product: "",
        },
        layPeak: {
          checked: false,
          product: "",
        },
        layFinal01: {
          checked: false,
          product: "",
        },
        layFinal02: {
          checked: false,
          product: "",
        },
        layFinal03: {
          checked: false,
          product: "",
        },
        layFinal04: {
          checked: false,
          product: "",
        },
        layFinal05: {
          checked: false,
          product: "",
        },
        layFinal06: {
          checked: false,
          product: "",
        },
      },
      phytaseHidosing: {
        preLay: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        prePeak: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        layPeak: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        layFinal01: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        layFinal02: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        layFinal03: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        layFinal04: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        layFinal05: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        layFinal06: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        approved: {
          checked: false,
          reason: "",
        },
      },
      carbohydraseBlends: {
        preLay: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        prePeak: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layPeak: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layFinal01: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layFinal02: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layFinal03: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layFinal04: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layFinal05: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layFinal06: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        approved: {
          checked: false,
          reason: "",
        },
      },
      enziPacProProtease: {
        preLay: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        prePeak: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layPeak: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layFinal01: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layFinal02: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layFinal03: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layFinal04: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layFinal05: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        layFinal06: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },

        approved: {
          checked: false,
          reason: "",
        },
      },
    },
    health: {
      therapeuticMedication: {
        preLay: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
        prePeak: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
        layPeak: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
        layFinal01: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
        layFinal02: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
        layFinal03: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
        layFinal04: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
        layFinal05: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
        layFinal06: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
      },
      performanceEnhancer: {
        preLay: {
          checked: false,
          product: "",
          from: "",
          to: "",
          dose: "",
        },
        prePeak: {
          checked: false,
          product: "",
          from: "",
          to: "",
          dose: "",
        },
        layPeak: {
          checked: false,
          product: "",
          from: "",
          to: "",
          dose: "",
        },
        layFinal01: {
          checked: false,
          product: "",
          from: "",
          to: "",
          dose: "",
        },
        layFinal02: {
          checked: false,
          product: "",
          from: "",
          to: "",
          dose: "",
        },
        layFinal03: {
          checked: false,
          product: "",
          from: "",
          to: "",
          dose: "",
        },
        layFinal04: {
          checked: false,
          product: "",
          from: "",
          to: "",
          dose: "",
        },
        layFinal05: {
          checked: false,
          product: "",
          from: "",
          to: "",
          dose: "",
        },
        layFinal06: {
          checked: false,
          product: "",
          from: "",
          to: "",
          dose: "",
        },
      },
    },
    minerals: {
      organics: {
        preLay: {
          checked: false,
          product: "",
          reason: "",
        },
        prePeak: {
          checked: false,
          product: "",
          reason: "",
        },
        layPeak: {
          checked: false,
          product: "",
          reason: "",
        },
        layFinal01: {
          checked: false,
          product: "",
          reason: "",
        },
        layFinal02: {
          checked: false,
          product: "",
          reason: "",
        },
        layFinal03: {
          checked: false,
          product: "",
          reason: "",
        },
        layFinal04: {
          checked: false,
          product: "",
          reason: "",
        },
        layFinal05: {
          checked: false,
          product: "",
          reason: "",
        },
        layFinal06: {
          checked: false,
          product: "",
          reason: "",
        },
        unknownConcept: false,
      },
      zincOxide: {
        preLay: {
          checked: false,
          ppm: "",
        },
        prePeak: {
          checked: false,
          ppm: "",
        },
        layPeak: {
          checked: false,
          ppm: "",
        },
        layFinal01: {
          checked: false,
          ppm: "",
        },
        layFinal02: {
          checked: false,
          ppm: "",
        },
        layFinal03: {
          checked: false,
          ppm: "",
        },
        layFinal04: {
          checked: false,
          ppm: "",
        },
        layFinal05: {
          checked: false,
          ppm: "",
        },
        layFinal06: {
          checked: false,
          ppm: "",
        },
      },
      copperSulfate: {
        preLay: {
          checked: false,
          ppm: "",
        },
        prePeak: {
          checked: false,
          ppm: "",
        },
        layPeak: {
          checked: false,
          ppm: "",
        },
        layFinal01: {
          checked: false,
          ppm: "",
        },
        layFinal02: {
          checked: false,
          ppm: "",
        },
        layFinal03: {
          checked: false,
          ppm: "",
        },
        layFinal04: {
          checked: false,
          ppm: "",
        },
        layFinal05: {
          checked: false,
          ppm: "",
        },
        layFinal06: {
          checked: false,
          ppm: "",
        },
      },
    },
    additions: {
      organicAcids: {
        preLay: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        prePeak: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layPeak: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal01: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal02: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal03: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal04: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal05: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal06: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        unknownConcept: false,
      },
      mycotoxinAdsorbents: {
        preLay: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        prePeak: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layPeak: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal01: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal02: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal03: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal04: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal05: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal06: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        unknownConcept: false,
      },
      essencialOils: {
        preLay: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        prePeak: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layPeak: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal01: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal02: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal03: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal04: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal05: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal06: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
      },
      prebiotics: {
        preLay: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        prePeak: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layPeak: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal01: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal02: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal03: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal04: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal05: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal06: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
      },
      probiotics: {
        preLay: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        prePeak: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layPeak: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal01: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal02: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal03: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal04: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal05: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        layFinal06: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
      },
      others: {
        emulsifiers: false,
        pigmentation: false,
        pigmentationType: "",
        preLay: {
          yellowppm: "",
          redppm: "",
        },
        prePeak: {
          yellowppm: "",
          redppm: "",
        },
        layPeak: {
          yellowppm: "",
          redppm: "",
        },
        layFinal01: {
          yellowppm: "",
          redppm: "",
        },
        layFinal02: {
          yellowppm: "",
          redppm: "",
        },
        layFinal03: {
          yellowppm: "",
          redppm: "",
        },
        layFinal04: {
          yellowppm: "",
          redppm: "",
        },
        layFinal05: {
          yellowppm: "",
          redppm: "",
        },
        layFinal06: {
          yellowppm: "",
          redppm: "",
        },
      },
    },
  };

  const [loading, setLoading] = useState(true);

  const [getMeggProduction, setGetMeggProduction] = useState(true);

  const [config, setConfig] = useState({});

  const [meggProduction, setMeggProduction] = useState(meggProductionInit);

  const [tab, setTab] = useState(0);

  const saveMeggProduction = async (e) => {
    const requestMeggProduction = { ...meggProduction };
    requestMeggProduction.customer = props.customer;
    requestMeggProduction._id = props.id || null;
    const response = await Swal.fire({
      title: "Histórico de Produção de Frango de Corte",
      text: "Deseja salvar alterações?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0451e8",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, Salvar!",
      showLoaderOnConfirm: true,
      preConfirm: async () =>
        props.id
          ? await api
              .put("meggproductionhistoric/" + props.id, requestMeggProduction)
              .catch((err) => ({
                err: true,
                data: { message: err.response.data.message },
              }))
          : await api
              .post("meggproductionhistoric", requestMeggProduction)
              .catch((err) => ({
                err: true,
                data: { message: err.response.data.message },
              })),
    });
    if (response.value) {
      Swal.fire(
        "Histórico de Produção de Frango de Corte",
        response.value.data.message,
        response.value.err ? "error" : "success"
      );
    }
    setUpdateList(true);
  };

  useEffect(() => {
    const loadMeggProduction = async () => {
      setLoading(true);
      const responseConfig = await api.get("meggproductionhistoric/config", {
        params: {
          query:
            "premixComposition premixAnimalFeedType premixPhysicalForm premixCommonDescription " +
            "customerHealthScore customerExportCuts enzymesPhytaseProduct enzymesPhytaseType " +
            "enzymesCarbohydraseBlendsProduct enzymesEnziPacProProteaseProduct healthAnticoccidianMolecule " +
            "healthTherapeuticMedicationType healthTherapeuticMedicationProduct healthPerformanceEnhancerProduct " +
            "mineralsOrganicsProduct additionsOrganicAcidsProduct additionsMycotoxinAdsorbentsProduct " +
            "additionsEssencialOilsProduct additionsPrebioticsProduct additionsProbioticsProduct othersPigmentationType",
        },
      });

      if (!responseConfig.data) {
        Swal.fire(
          "Editar Configurações",
          "Não foi possível buscar configurações",
          "error"
        );
      }
      setConfig([...responseConfig.data]);

      const response = await api.get(
        props.id
          ? `meggproductionhistoric/edit/${props.id}`
          : `meggproductionhistoric/${props.customer}`
      );
      if (!response.data) {
        return setLoading(false);
      }
      const meggProductionCopy = getInitialObject(
        { ...meggProduction },
        response.data
      );

      setMeggProduction(meggProductionCopy);
      setLoading(false);
    };
    if (getMeggProduction) {
      setGetMeggProduction(false);
      loadMeggProduction();
    }
  }, [meggProduction, getMeggProduction, props.customer, props.id]);

  return (
    <Modal
      show={props.show}
      close={() => props.setShow(false)}
      header={
        <>
          <Icons type="meggProduction" color="#009870" size={30} />
          <h2>Histórico - MEgg - Produção</h2>
        </>
      }
      footer={
        <Button
          color="white"
          bg="default"
          border="default"
          onClick={saveMeggProduction}
        >
          Salvar
        </Button>
      }
    >
      {loading ? (
        <ReactLoading type="spin" color="#009870" height={30} width={30} />
      ) : (
        <>
          <Tabs
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="on"
            onChange={(e, value) => {
              setTab(value);
            }}
          >
            <Tab label="Cliente" />
            <Tab label="Premix/Ração" />
            <Tab label="Enzimas" />
            <Tab label="Saúde" />
            <Tab label="Minerais" />
            <Tab label="Aditivos" />
          </Tabs>
          {tab === 0 && (
            <Customer
              meggProduction={meggProduction}
              setMeggProduction={setMeggProduction}
              config={config}
              editing={props.editing}
            />
          )}
          {tab === 1 && (
            <Premix
              meggProduction={meggProduction}
              setMeggProduction={setMeggProduction}
              config={config}
            />
          )}
          {tab === 2 && (
            <Enzymes
              meggProduction={meggProduction}
              setMeggProduction={setMeggProduction}
              config={config}
            />
          )}
          {tab === 3 && (
            <Health
              meggProduction={meggProduction}
              setMeggProduction={setMeggProduction}
              config={config}
            />
          )}
          {tab === 4 && (
            <Minerals
              meggProduction={meggProduction}
              setMeggProduction={setMeggProduction}
              config={config}
            />
          )}
          {tab === 5 && (
            <Additions
              meggProduction={meggProduction}
              setMeggProduction={setMeggProduction}
              config={config}
            />
          )}
        </>
      )}
    </Modal>
  );
}
